import React, { Component } from 'react';

var KiotSpinner = null;
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import PreviewFeedbackForm from './PreviewFeedbackForm';

import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;



var FIELD_TYPES = [
  {
    key: "shortanswer",
    value: "Text Field"
  },
  {
    key: "longanswer",
    value: "Text Area"
  },
  {
    key: "rating",
    value: "Rating (Stars)"
  },
  {
    key: "multiplechoice",
    value: "Multiple Choice"
  },
  {
    key: "checkbox",
    value: "Checkboxes"
  },
  {
    key: "dropdown",
    value: "Dropdown"
  },
  {
    key: "date",
    value: "Date"
  },
  {
    key: "time",
    value: "Time"
  }
];

var OPTIONS_FIELDS = {
  multiplechoice: 1,
  checkbox: 1,
  dropdown: 1
}


export default class NewFeedbackTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.formDetail ? this.props.formDetail.title : "Enter your title here",
      description: this.props.formDetail ? this.props.formDetail.description : "",
      survey_sections: this.props.formDetails ? this.props.formDetails.survey_sections : [],
      is_edit: this.props.formDetails,
      spinner: null,
      preview: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    if (!this.state.is_edit) {
      this.addNewSection();
    }
  }

  getPayload() {
    return {
      title: this.state.title,
      description: this.state.description,
      survey_sections: this.state.survey_sections
    }
  }

  saveForm() {
    if (this.validateAllSections()) {
      this.setState({
        spinner: <KiotSpinner />
      })
      if (!this.state.is_edit) {
        ds.postCreateSurveyForm({
          ...this.getPayload()
        }, data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Form Saved",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          this.setState({
            spinner: null,
            dialog
          })

        }, err => {
          this.setState({
            spinner: null
          })
        })
      }
      else {
        ds.postEditSurveyForm({
          ...this.getPayload(),
          _id: this.props.formDetails._id
        }, data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Form Saved",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          this.setState({
            spinner: null,
            dialog
          })

        }, err => {
          this.setState({
            spinner: null
          })
        })
      }
    }
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    })

  }

  addNewSection() {
    let survey_sections = this.state.survey_sections
    survey_sections.push({
      title: "Section " + (survey_sections.length + 1).toString(),
      description: "",
      questions: []
    })
    this.setState({
      survey_sections: survey_sections

    }, () => {
      this.addNewQuestion(this.state.survey_sections.length - 1);
    });
  }

  deleteSection(s_ind) {
    let survey_sections = this.state.survey_sections
    survey_sections.splice(s_ind, 1);
    this.setState({
      survey_sections: survey_sections
    });
  }

  addNewQuestion(ind, type = 0) {
    let survey_sections = this.state.survey_sections
    survey_sections[ind].questions.push({
      title: "",
      field_type: type ? type : "shortanswer",
      options: [],
      stars: 5,
      is_required: false
    })
    this.setState({
      survey_sections: survey_sections

    }, () => {
      this.addNewOption(ind, this.state.survey_sections[ind].questions.length - 1, "1")
    });
  }

  deleteQuestion(survey_ind, question_ind) {
    let survey_sections = this.state.survey_sections
    survey_sections[survey_ind].questions.splice(question_ind, 1);
    this.setState({
      survey_sections: survey_sections
    });
  }

  addNewOption(survey_ind, question_ind, num) {
    let survey_sections = this.state.survey_sections
    survey_sections[survey_ind].questions[question_ind].options.push({
      option: "option " + num.toString(),
      value: ""
    })
    this.setState({
      survey_sections: survey_sections
    });
  }

  deleteOption(survey_ind, question_ind, op_ind) {
    let survey_sections = this.state.survey_sections
    survey_sections[survey_ind].questions[question_ind].options.splice(op_ind, 1);
    this.setState({
      survey_sections: survey_sections
    });
  }

  validateAllSections() {
    let s_ind = 0;
    let q_ind = 0;
    for (let section of this.state.survey_sections) {
      for (let question of section.questions) {
        if (!question.title) {
          let dialog = {
            open: true,
            head: 'Invalid',
            body: 'Please fill questions in all sections (question ' + (q_ind + 1).toString() + (this.state.survey_sections.length > 1 ? 'in section' + (s_ind + 1).toString() + ')' : ')'),
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          this.setState({ dialog })
          return false;
        }
        q_ind++;
      }
      s_ind++;
    }
    if (!this.state.title) {
      let dialog = {
        open: true,
        head: 'Invalid',
        body: 'Form title can not be empty',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      this.setState({ dialog })

      return false;
    }
    return true;
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleChangesSection(ind, field, e) {
    let survey_sections = this.state.survey_sections;
    survey_sections[ind][field] = e.target.value;
    this.setState({
      survey_sections: survey_sections
    });
  }

  handleChangesQuestion(sind, qind, field, e, i, val) {
    let survey_sections = this.state.survey_sections;
    survey_sections[sind].questions[qind][field] = val;
    this.setState({
      survey_sections: survey_sections
    });
  }

  handleChangesOption(sind, qind, oind, field, e) {
    let survey_sections = this.state.survey_sections;
    survey_sections[sind].questions[qind].options[oind][field] = e.target.value;
    this.setState({
      survey_sections: survey_sections
    });
  }

  render() {
    return (
      <div>
        {
          this.state.preview ? <PreviewFeedbackForm form={{ ...this.state }} 
            unMountMe={() => {
              this.setState({
                preview: false
              })
            }} 
          /> 
          :
          <Box header='New Feedback Form Template'>
            <Dialog
              title={this.state.dialog.head}
              actions={this.state.dialog.actions}
              modal={false}
              open={this.state.dialog.open}
              onRequestClose={this.closeDialog.bind(this)}
            >
              {this.state.dialog.body || 'NA'}
            </Dialog>

            <div>
              <div className="smart-form">
                <fieldset>
                  <section>
                    <TextField
                      floatingLabelText="Form Title"
                      className="w-100 font-2rem"
                      onFocus={(e) => { e.target.select(); }}
                      value={this.state.title}
                      name="title"
                      onChange={this.handleChanges.bind(this)}
                    />
                  </section>

                  <section>
                    <TextField
                      floatingLabelText="Form Description"
                      className="w-100"
                      name="description"
                      value={this.state.description} onChange={this.handleChanges.bind(this)}
                    />
                  </section>

                  <FlatButton
                    label="Add Section"
                    className="my-btn pull-right"
                    onClick={this.addNewSection.bind(this)}
                    type="button"
                  />
                </fieldset>

                {
                  this.state.survey_sections && this.state.survey_sections.length ?
                    this.state.survey_sections.map((obj, sind) => {
                      return <fieldset className="smart-form " 
                        style={{
                          "margin": "2rem",
                          "border": "1px solid #ddd",
                          "padding": "2rem"
                        }} 
                        key={'section' + sind} className={sind != this.state.survey_sections.length - 1 ? "feedback-section-divider" : ''}>

                        <header>
                          <TextField
                            floatingLabelText="Name"
                            name="name"
                            className="w-100 section-name"
                            value={obj.title}
                            onFocus={(e) => { e.target.select(); }} onChange={this.handleChangesSection.bind(this, sind, 'title')}
                          />

                          <TextField
                            floatingLabelText="description"
                            name="name"
                            className="w-100"
                            value={obj.description}
                            onChange={this.handleChangesSection.bind(this, sind, 'description')} 
                          />

                          {
                            this.state.survey_sections.length > 1 ?
                              <FlatButton
                                label="Delete Section"
                                className="pull-right"
                                onClick={this.deleteSection.bind(this, sind)}
                                type="button"
                                style={{color:'red'}}
                              /> 
                            : null
                          }
                        </header>

                        <br />

                        <h4>Questions</h4>
                        <fieldset>
                          {
                            obj.questions.map(
                              (question, qind) => {
                                return <div className="mt-1-3vw" key={"question" + qind}>
                                  <Box header={'Question ' + (qind + 1)}>
                                    <div className="p-0 m-0 txt-white">
                                      {
                                        this.state.survey_sections[sind].questions.length > 1 ?
                                          <FlatButton
                                            label="Delete"
                                            onClick={this.deleteQuestion.bind(this, sind, qind)}
                                            className="btn btn-trans float-right font-2rem mr-1vw"
                                            type="button"
                                            style={{color:'red'}}
                                          /> 
                                        : null
                                      }
                                    </div>

                                    <div>
                                      <div className="widget-body p-2vw" style={{ "paddingTop": 0 }}>
                                        <section>
                                          <TextField
                                            floatingLabelText={`Question ${qind + 1}`}
                                            name="name"
                                            className="w-100 font-2rem"
                                            value={question.title}
                                            onChange={(e) => { this.handleChangesQuestion(sind, qind, 'title', null, null, e.target.value) }} />
                                        </section>

                                        <section>
                                          <SelectField
                                            floatingLabelText="Answer Type"
                                            value={question.field_type}
                                            name="field_type"
                                            className="w-100"
                                            onChange={this.handleChangesQuestion.bind(this, sind, qind, 'field_type')}>
                                            {
                                              FIELD_TYPES.length ?
                                                FIELD_TYPES.map(obj => {
                                                  return <MenuItem key={obj.key} value={obj.key} primaryText={obj.value} />
                                                }) 
                                              : null
                                            }
                                          </SelectField>
                                        </section>

                                        {
                                          question.field_type == "rating" && <TextField
                                            floatingLabelText={`Number of Stars`}
                                            type="number"
                                            className="w-75 font-1-5rem"
                                            value={question.stars}
                                            onFocus={(e) => { e.target.select(); }}
                                            onChange={(e) => { this.handleChangesQuestion(sind, qind, 'stars', null, null, e.target.value) }} 
                                          />
                                        }

                                        {
                                          OPTIONS_FIELDS[question.field_type] ?
                                            question.options && question.options.length ?
                                              question.options.map((option, oind) => {
                                                return <div key={oind + " qfileds"}>
                                                  <TextField
                                                    floatingLabelText={`Option ${oind + 1}`}
                                                    className="w-75 font-1-5rem"
                                                    value={option.option}
                                                    onFocus={(e) => { e.target.select(); }}
                                                    onChange={this.handleChangesOption.bind(this, sind, qind, oind, 'option')} />
                                                  {
                                                    question.options.length > 1 ?
                                                      <FlatButton style={{ minWidth: "3vw" }} className="font-1-5rem m-1vw btn-none" onClick={this.deleteOption.bind(this, sind, qind, oind)}>
                                                        <i className="nav-icon material-icons warn-fg ">delete</i>
                                                      </FlatButton>
                                                    : null
                                                  }

                                                  {
                                                    oind == question.options.length - 1 ?
                                                      <FlatButton style={{ minWidth: "3vw" }} onClick={this.addNewOption.bind(this, sind, qind, question.options.length + 1)}>
                                                        <span className="link-fg font-2rem"> +</span>
                                                      </FlatButton> 
                                                    : null
                                                  }

                                                </div>
                                              }) 
                                            : null
                                          : null
                                        }

                                        <section className="pull-right">
                                          <label className="label"></label>

                                          <div className="inline-group">
                                            <Checkbox label="Mandatory" checked={question.is_required ? true : false}
                                              onCheck={(e) => {
                                                let survey_sections = this.state.survey_sections;
                                                survey_sections[sind].questions[qind]['is_required'] = e.target.checked;
                                                this.setState({
                                                  survey_sections: survey_sections
                                                })
                                              }
                                              } 
                                            />
                                          </div>
                                        </section>
                                      </div>
                                    </div>
                                  </Box>
                                </div>
                              }
                            )
                          }

                          <FlatButton
                            label="Add Question"
                            className="btn btn-primary my-btn pull-right"
                            onClick={this.addNewQuestion.bind(this, sind)}
                            className="btn btn-trans float-right font-2rem mr-1vw"
                            type="button"
                          />

                        </fieldset>
                      </fieldset>
                    }) 
                  : null
                }
                <br /><br />

                <div>
                  <RaisedButton
                    label="Save Form"
                    primary
                    className="pull-right"
                    onClick={this.saveForm.bind(this)}
                    type="button"
                  />
                  <FlatButton
                    label="Preview Form"
                    primary
                    style={{ marginRight: "1rem" }}
                    onClick={() => {
                      this.setState({
                        preview: true
                      })
                    }}
                    className="pull-right"
                    type="button"
                  />
                </div>

              </div>
            </div>
          </Box>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/feedback/NewFeedbackTemplate.js